import { DriverStatus } from './types.js';

/** Driver status styling configuration. */
export const DriverStatusStyles = Object.freeze({
  [DriverStatus.BETA]: {
    bg: 'bg-base-200',
    text: 'text-white',
    label: 'BETA'
  }
} as const);
